module.exports = __webpack_public_path__ + "assets/img/muying_case.110af605.png";